"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyScheduleModelsConverter = void 0;
const CommonScheduleModelsConverter_1 = require("./CommonScheduleModelsConverter");
require("./types");
class MonthlyScheduleModelsConverter extends CommonScheduleModelsConverter_1.CommonScheduleModelsConverter {
    static toControlModel(value) {
        return Object.assign({ isEnabled: value.isEnabled, isModified: value.isModified, isArchiveEnabled: value.isArchiveEnabled, isArchiveVisible: value.isArchiveVisible, fieldTimeValue: value.fields.time, fieldDayNumberInMonthValue: value.fields.dayNumberInMonth, fieldDayOfWeekValue: value.fields.dayOfWeek, fieldDayOfMonthValue: value.fields.dayOfMonth }, this.convertScheduleRowsToControlModel(value));
    }
    static toMainModel(value, currentModelValue) {
        return Object.assign(Object.assign({}, CommonScheduleModelsConverter_1.CommonScheduleModelsConverter.convertScheduleRowsToMainModel(value, currentModelValue)), { isArchiveEnabled: value.isArchiveEnabled, isArchiveVisible: value.isArchiveVisible, fields: {
                time: value.fieldTimeValue,
                dayNumberInMonth: value.fieldDayNumberInMonthValue,
                dayOfWeek: value.fieldDayOfWeekValue,
                dayOfMonth: value.fieldDayOfMonthValue,
            } });
    }
}
exports.MonthlyScheduleModelsConverter = MonthlyScheduleModelsConverter;
//# sourceMappingURL=MonthlyScheduleModelsConverter.js.map